import * as yup from 'yup';

export const createTeamValidationSchema = yup.object({
  businessHeadId: yup.string().required('Business head is required'),
  customerIds: yup.array().of(yup.string().required()).optional(),
  jobSourceIds: yup
    .array()
    .of(yup.string().required())
    .min(1, 'At least one job source must be selected')
    .required('Job source mapping is required'),
  teamCode: yup
    .string()
    .required('Team code is required')
    .min(2, 'Team code must be at least 2 characters')
    .max(10, 'Team code must not exceed 10 characters')
    .matches(
      /^[A-Z0-9]+$/,
      'Team code must contain only uppercase letters and numbers',
    ),
  teamCustomers: yup
    .array()
    .of(
      yup.object({
        customerId: yup.string().required(),
        jobSourceId: yup.string().required(),
      }),
    )
    .optional(),
  teamManagerId: yup.string().required('Manager is required'),
  teamName: yup
    .string()
    .required('Team name is required')
    .min(3, 'Team name must be at least 3 characters')
    .max(50, 'Team name must not exceed 50 characters'),
  teamType: yup.string().required('Type is required'),
  workingHoursEnd: yup.string().required('Working hours end is required'),
  workingHoursStart: yup.string().required('Working hours start is required'),
});

export type TeamCustomerMapping = {
  customerId: string;
  jobSourceId: string;
};

export type CreateTeamFormData = yup.InferType<
  typeof createTeamValidationSchema
>;
